import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '../../../../../auth/auth.service';
import { AuthGroupTypesEnum } from 'src/app/pages/auth/auth-group-types.enum';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-monitoring-filter',
  templateUrl: './monitoring-filter.component.html',
  styleUrls: ['./monitoring-filter.component.scss'],
  standalone: false,
})
export class MonitoringFilterComponent {
  @Input() filter;
  @Input() loading;

  constructor(private authService: AuthService) { }
  
  get isDispatcher(): boolean {
    return this.authService.is(AuthGroupTypesEnum.Dispatcher)
  }

  get isGRS() {
    return this.authService.isGRSUser();
  }
}
